import { formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { LogicLog } from 'src/model/class/general classes/logic-log';
import { StaticClass } from 'src/components/shared-components/class/general-classes/static-classes';
import { TranslationService } from 'src/service/translation.service';

@Component({
    selector: 'app-info-popup-alarm',
    templateUrl: './info-popup-alarm.component.html',
    styleUrls: ['./info-popup-alarm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoPopupAlarmComponent implements OnInit, OnChanges {
  @Input() selectedAlarm: LogicLog;

  public icon: string = "";

  constructor(
    private _translationService: TranslationService
  ) { }

  ngOnInit() {
    this.icon = StaticClass.GetTypeAlarm(this.selectedAlarm.idTypeAlarm);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.icon = StaticClass.GetTypeAlarm(this.selectedAlarm.idTypeAlarm);
  }

  /**
   * Returns the formatted date.
   */
  public formatDate() {
    return formatDate(this.selectedAlarm.timeStamp, "mediumDate", this._translationService.currentLanguage);
  }

  /**
   * Returns the formatted time.
   */
  public formatTime() {
    return formatDate(this.selectedAlarm.timeStamp, "mediumTime", this._translationService.currentLanguage);
  }
}
